// Create and setup your form here

<template>
  <div>
    <flow-form
      ref="flowform"
      v-on:complete="onComplete"
      v-bind:language="language"
      v-bind:progressbar="false"
      v-bind:standalone="true"
    >
      <question
        v-for="(question, index) in questions"
        v-bind="question"
        v-bind:key="'m' + index"
        v-model="question.model"
      >
      </question>

      <!-- Custom content for the Complete/Submit screen slots in the FlowForm component -->
      <template v-slot:complete>
        <div class="f-section-wrap">
          <div v-if="questions[0].model === 'author_publisher'">
            <span class="f-tagline">Submit issue &gt; Step 3/3</span>
            <div v-if="loading">
              <span class="fh2">Please wait, submitting...</span>
            </div>
            <div v-else>
              <p class="f-description">
                <span
                  >Thank You 😊. We will verify your link and send out invites
                  soon. All the Best!!</span
                >
              </p>
            </div>
          </div>
          <div v-else>
            <span class="fh2"
              >Thanks for taking out the time to take our survey.😉</span
            >
            <p class="f-description"><span>Have a great day!</span></p>
          </div>
        </div>
      </template>
      <!-- We've overriden the default "complete" slot content -->
      <template v-slot:completeButton>
        <div class="f-submit">
          <!-- Leave empty to hide default submit button -->
        </div>
      </template>
    </flow-form>
  </div>
</template>

<script>
// Import necessary components and classes
import { mapGetters } from "vuex";
import FlowForm from "@/components/vueFlow/components/FlowForm.vue";
import Question from "@/components/vueFlow/components/Question.vue";
import LanguageModel from "@/components/vueFlow//models/LanguageModel";

// If using the npm package, use the following line instead of the ones above.
// import FlowForm, Question, { LanguageModel } from '@ditdot-dev/vue-flow-form'

export default {
  name: "Shelf",
  components: {
    FlowForm,
    Question
  },
  computed: {
    ...mapGetters({
      user: "user/user",
      profile: "user/profile"
    })
  },
  data() {
    return {
      loading: false,
      completed: false,
      language: new LanguageModel(),
      questions: [
        {
          type: "multiplechoice",
          id: "question_1",
          tagline: "Welcome to HeartBeatFam!",
          title:
            "How would you feel if you could no longer use HeartBeatFam?",
          multiple: false,
          required: true,
          helpTextShow: false,
          options: [
            {
              label: "Very disappointed",
              value: "very_disappointed"
            },
            {
              label: "Somewhat disappointed",
              value: "somewhat_disappointed"
            },
            {
              label: "Not disappointed",
              value: "somewhat_disappointed"
            }
          ],
          model: ""
        },
        {
          type: "text",
          id: "question_2",
          tagline: "",
          title:
            "What type of people do you think would most benefit from HeartBeatFam?",
          multiple: false,
          required: true,
          helpTextShow: false,
          placeholder: "",
          model: ""
        },
        {
          type: "text",
          id: "question_3",
          tagline: "",
          title: "What is the main benefit you receive from HeartBeatFam?",
          multiple: false,
          required: true,
          helpTextShow: false,
          placeholder: "",
          model: ""
        },
        {
          type: "text",
          id: "question_4",
          tagline: "",
          title: "How can we improve HeartBeatFam for you?",
          multiple: false,
          required: true,
          helpTextShow: false,
          placeholder: "",
          model: ""
        },
        {
          type: "text",
          id: "question_5",
          tagline: "",
          title: "What is your email?",
          multiple: false,
          required: true,
          helpTextShow: false,
          placeholder: "",
          model: ""
        }
      ]
    };
  },
  methods: {
    //TODO- Put in mixin: saveToDb, OnComplete, onSendData, getData
    saveToDb(dataFromForm, formId = "default", sessionCookieName = "default") {
      console.log("Aving1");

      const sessionCookie = "test cookies"; //this.checkSession(sessionCookieName);  -- //TODO understand this cookie

      const data = {
        form: {
          user: this.user ? this.user.uid : null,
          cookie: sessionCookie,
          ip: this.res ? (this.res.data ? this.res.data.ip : this.res) : null,
          data: dataFromForm
        },
        form_id: formId
      };
      console.log("Aving2");

      this.$store.dispatch("user/saveForm", data).then(() => {
        this.$emit("complete", dataFromForm);
      });
    },
    /* eslint-disable-next-line no-unused-vars */
    onComplete(completed, questionList) {
      // This method is called whenever the "completed" status is changed.
      this.completed = completed;

      // Set `submitted` to true so the form knows not to allow back/forward
      // navigation anymore.
      this.$refs.flowform.submitted = true;

      this.onSendData();
    },

    onSendData() {
      const self = this;
      const data = this.getData();

      this.loading = true;
      this.saveToDb(data, "survey_feedback_users", "signup_authorpublisher");

      /*
        You can use Fetch API to send the data to your server, eg.:

        fetch(url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(data)
        })
      */

      setTimeout(() => {
        self.loading = false;
      }, 1500);
    },

    getData() {
      const data = {
        questions: [],
        answers: []
      };

      this.questions.forEach(question => {
        if (question.title) {
          let answer = question.model;
          if (Array.isArray(answer)) {
            answer = answer.join(", ");
          }

          data.questions.push(question.title);
          data.answers.push(answer);
        }
      });

      return data;
    },

    formatTicket(ticket) {
      return ticket && ticket.replace(/-/g, "");
    }
  }
};
</script>

<style lang="css" scoped>
@import "../_themes/theme-standard.css";
</style>
